module.exports = __webpack_public_path__ + "static/media/circleFrame3.51d1a3ea.svg";